import { render } from "./DpiBox.vue?vue&type=template&id=9a8c12c8&scoped=true"
import script from "./DpiBox.vue?vue&type=script&lang=js"
export * from "./DpiBox.vue?vue&type=script&lang=js"

import "./DpiBox.vue?vue&type=style&index=0&id=9a8c12c8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a8c12c8"]])

export default __exports__